
export function parseJSON(json_str) {
  let _json = {}
  try {
    _json = JSON.parse(json_str)
  } catch (error) {
    _json = {}
  }
  return _json
}

export function getQueryString(val){
 const w = location.hash.indexOf('?');
  const query = location.hash.substring(w + 1);

  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] == val) { 
      //console.log(pair[1])
      return pair[1]; }
  }

  return false;
}


export function setQueryLS(query = {}){
    localStorage.setItem("homeQuery", JSON.stringify(query));
    localStorage.setItem(
      "registrationSource",
      query.registrationSource || "CBS_APP"
    );
    localStorage.setItem("device", query.device || "APP");
    localStorage.setItem("tenantCode", query.tenantCode || "");

}
export const waterMarkOpts={
    wWidth:500,
    wHeight: 140,
    wTop: "0px",
    wLeft: "0px",
    wRotateDeg: 15,
    wFontSize: "14px",
    // wFont: "1.2rem Vedana",
    wColor: "#666",
    wOpacity: "0.2",
    wZIndex: "100000",
}
// 金额千分位
export function NumFormat(num) {
  num= Number(num)
  if(getQueryString('numberFormat')){
    localStorage.setItem('numberFormat',decodeURIComponent(getQueryString('numberFormat')))
  }
  if (typeof num != 'number') return
  let numberFormat=JSON.parse(localStorage.getItem('numberFormat'))
  // let numberFormat={
  //   "decimalFormat": {
  //     "digit": 2,
  //     "symbol": ","
  //   },
  //   "thousandsFormat": {
  //     "digit": 3,
  //     "symbol": "."
  //   }
  // }
  let thousandDigit=numberFormat.thousandsFormat.digit?numberFormat.thousandsFormat.digit:3//千分位位数
  let thousandSymbol=numberFormat.thousandsFormat.symbol?numberFormat.thousandsFormat.symbol:','//千分位符号
  let decimalDigit=numberFormat.decimalFormat.digit?numberFormat.decimalFormat.digit:2//小数点位数
  let decimalSymbol=numberFormat.decimalFormat.symbol?numberFormat.decimalFormat.symbol:'.'//小数点符号
   // 判断负数的情况
  let isNegative =num < 0;
  if (isNegative) num = Math.abs(num); // 取绝对值
  // 将数字转换为字符串
  //console.log(num)
  let numStr = num.toFixed(decimalDigit);
  
  // 使用正则表达式和 slice() 方法实现千分位格式化
  let parts = numStr.split('.');
  let integerPart = parts[0]; // 获取整数部分
  let decimalPart = parts[1] ?decimalSymbol + parts[1] : ''; // 获取小数部分（如果有的话）

    // 创建动态的正则表达式，根据 separatorInterval 参数来调整每隔多少位插入分隔符
    const regex = new RegExp(`\\B(?=(\\d{${thousandDigit}})+(?!\\d))`, 'g');
    // 在整数部分添加千分位分隔符（使用 . 作为分隔符）
  let formattedInteger = integerPart.replace(regex, thousandSymbol);

  // 返回格式化后的数字
  return (isNegative ? '-' : '') + formattedInteger + decimalPart;
}
import moment from "moment";
export function formatTime(t, isShowTime) {
  let langCode =  localStorage.getItem('language');
  if (t) {
    if (['en_AR', 'en_TH', 'en_US'].includes(langCode)) {
      return isShowTime ? moment(t).format('hh:mm:ss A MM/DD/YYYY') : moment(t).format('MM/DD/YYYY');
    } else if (['th_TH', 'vi_VN', 'ar_AE'].includes(langCode)) {
      return isShowTime ? moment(t).format('HH:mm:ss DD/MM/YYYY') : moment(t).format('DD/MM/YYYY');
    } else {
      //zh_CN
      return isShowTime ? moment(t).format('HH:mm:ss YYYY/MM/DD') : moment(t).format('YYYY/MM/DD');
    }
  } else {
    if (['en_AR', 'en_TH', 'en_US'].includes(langCode)) {
      return isShowTime ? 'hh:mm:ss A MM/DD/YYYY' : 'MM/DD/YYYY';
    } else if (['th_TH', 'vi_VN', 'ar_AE'].includes(langCode)) {
      return isShowTime ? 'HH:mm:ss DD/MM/YYYY' : 'DD/MM/YYYY';
    } else {
      //zh_CN
      return isShowTime ? 'HH:mm:ss YYYY/MM/DD' : 'YYYY/MM/DD';
    }
  }
}


// WEBPACK FOOTER //
// src/util/index.js